export const homeModuleTranslations = {
  en: {
    "About us": "About us",
  },
  zh: {
    "About us": "关于我们",
  },
  "zh-TW": {
    "About us": "關於我們",
    "home.warranty.years": "年",
    "home.warranty.label": "保固",
  },
  fr: {
    "About us": "À propos de nous",
    "home.warranty.years": "ans",
    "home.warranty.label": "Garantie",
  },
  es: {
    "About us": "Sobre nosotros",
    "home.warranty.years": "años",
    "home.warranty.label": "Garantía",
  },
  ar: {
    "About us": "من نحن",
    "home.warranty.years": "سنوات",
    "home.warranty.label": "الضمان",
  },
  ja: {
    "About us": "私たちについて",
    "home.warranty.years": "年",
    "home.warranty.label": "保証",
  },
  ru: {
    "About us": "О нас",
    "home.warranty.years": "лет",
    "home.warranty.label": "Гарантия",
  },
  ko: {
    "About us": "회사 소개",
    "home.warranty.years": "년",
    "home.warranty.label": "보증",
  },
  pt: {
    "About us": "Sobre nós",
    "home.warranty.years": "anos",
    "home.warranty.label": "Garantia",
  },
  "pt-BR": {
    "About us": "Sobre nós",
    "home.warranty.years": "anos",
    "home.warranty.label": "Garantia",
  },
  it: {
    "About us": "Chi siamo",
    "home.warranty.years": "anni",
    "home.warranty.label": "Garanzia",
  },
  de: {
    "About us": "Über uns",
    "home.warranty.years": "Jahre",
    "home.warranty.label": "Garantie",
  },
  hi: {
    "About us": "हमारे बारे में",
    "home.warranty.years": "साल",
    "home.warranty.label": "वारंटी",
  },
  mn: {
    "About us": "Бидний тухай",
    "home.warranty.years": "жил",
    "home.warranty.label": "Баталгаа",
  },
  th: {
    "About us": "เกี่ยวกับเรา",
    "home.warranty.years": "ปี",
    "home.warranty.label": "การรับประกัน",
  },
  uk: {
    "About us": "Про нас",
    "home.warranty.years": "років",
    "home.warranty.label": "Гарантія",
  },
  vi: {
    "About us": "Về chúng tôi",
    "home.warranty.years": "năm",
    "home.warranty.label": "Bảo hành",
  },
  id: {
    "About us": "Tentang kami",
    "home.warranty.years": "tahun",
    "home.warranty.label": "Garansi",
  },
  tl: {
    "About us": "Tungkol sa amin",
    "home.warranty.years": "taon",
    "home.warranty.label": "Warranty",
  },
  bn: {
    "About us": "আমাদের সম্পর্কে",
    "home.warranty.years": "বছর",
    "home.warranty.label": "ওয়ারেন্টি",
  },
};
